import { render, staticRenderFns } from "./APIWiki.vue?vue&type=template&id=0e3f5cf6&scoped=true&"
import script from "./APIWiki.vue?vue&type=script&lang=ts&"
export * from "./APIWiki.vue?vue&type=script&lang=ts&"
import style0 from "./APIWiki.vue?vue&type=style&index=0&id=0e3f5cf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3f5cf6",
  null
  
)

export default component.exports